import { CASINOGAME_FILTER_TAB, PROMOTION_FILTER_TAB } from '../config';
export const findSportId = (entry) => {
    var _a, _b, _c;
    switch (entry.type) {
        case 'sport':
            return (_a = entry === null || entry === void 0 ? void 0 : entry.value) === null || _a === void 0 ? void 0 : _a.id;
        case 'event':
        case 'race':
        case 'league':
        case 'match':
        case 'selection':
            return (_c = (_b = entry === null || entry === void 0 ? void 0 : entry.value) === null || _b === void 0 ? void 0 : _b.sport) === null || _c === void 0 ? void 0 : _c.id;
        case 'casinogame':
            return 'casinogame';
        case 'promotion':
            return 'promotion';
        case 'helpanswer':
        case 'helparticle':
        case 'xsell':
        case 'static':
        case 'tournament':
        default:
            return null;
    }
};
export const getAllSportsInEntries = (sports, entries) => {
    const setOfSportIds = new Set();
    entries.forEach((item) => {
        const sportId = findSportId(item);
        if (sportId) {
            setOfSportIds.add(sportId);
        }
    });
    const filterTable = [
        ...sports.slice(0, 2),
        CASINOGAME_FILTER_TAB,
        PROMOTION_FILTER_TAB,
        ...sports.slice(2, sports.length - 1),
    ];
    return filterTable.filter((sport) => setOfSportIds.has(sport.id));
};
//# sourceMappingURL=filterBySports.js.map